module.exports = __webpack_public_path__ + "img/insert_emoticon.svg";